<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth', 'currentCustomer'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'agreement-create-' + new Date().getTime(),
				},

				customers: [],
				customer: null,

				providers: [],
				provider: null,

				disabledCustomers: false,
				disabledproviders: false,

				statuses: null,

				intervals: [],
				interval: null,

				item: {
					title: null,
					start: '',
					end: '',
					customer_id: null,
					provider_id: null,
					time_interval_id: null,
					agreement_status_id: 1,
				},

				multiselect: {
					loading: false,
				}
			}
		},
		watch: {
			customer() {
				if(this.customer) {
					this.disabledproviders = true
					this.provider = null
					this.item.customer_id = this.customer.id
				} else {
					this.disabledproviders = false
					this.item.customer_id = null
				}
			},
			provider() {
				if(this.provider) {
					this.disabledCustomers = true
					this.customer = null
					this.item.provider_id = this.provider.id
				} else {
					this.disabledCustomers = false
					this.item.provider_id = null
				}
			},
			interval() {
				if(this.interval) {
					this.item.time_interval_id = this.interval.id
				} else {
					this.item.time_interval_id = null
				}
			}
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
			modal.on('hidden.bs.modal', function () {
				that.clearData()
			})
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				if(this.currentCustomer) {
					this.customer = this.currentCustomer
				}
				this.getProviders()
				this.getStatuses()
				this.getIntervals()
			},
			clearData() {
				this.item.title = null
				this.item.start = ''
				this.item.end = ''
				this.item.customer_id = null
				this.item.provider_id = null
				this.item.time_interval_id = null
				this.item.agreement_status_id = 1

				this.customer = null
				this.provider = null
				this.interval = null
				this.errors.clear()
			},
			getCustomers(text) {
				this.multiselect.loading = true
				this.customers = []
				this.$http.get('admin/customers?per_page=50&sort=id|desc&text=' + text)
				.then(response => {
					this.customers = response.body.data
					this.multiselect.loading = false
				}).catch(response => {
					console.log(response)
					this.multiselect.loading = false
				})
			},
			getProviders() {
				this.$http.get('admin/management/providers')
				.then(response => {
					this.providers = response.body
				})
			},
			getStatuses() {
				this.$http.get('admin/agreements/statuses')
				.then(response => {
					this.statuses = response.body
					this.item.agreement_status_id = 1
				})
			},
			getIntervals() {
				this.$http.get('admin/time/intervals')
				.then(response => {
					this.intervals = response.body
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					if(that.$validator.errors.items.length) {
						that.$el.querySelector('[name=' + that.$validator.errors.items[0].field + ']').focus()
					}
					return result
				})
			},
			store () {
				var btnStore = Ladda.create(this.$refs.btnStore)
				btnStore.start()
				this.$http.post('admin/agreements', this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					btnStore.stop()
					this.editOrContinue(response)
				}).catch(function(response) {
					console.log(response)
					btnStore.stop()
					this.$emit('reload')
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
			editOrContinue(response) {
				var agreement = response.body.data
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + "/admin/management/agreements/" + agreement.id + '/edit')
				}).catch(swal.noop)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/agreements/views/Create.vue